

const CLASS_NAMES = Object.freeze({
  VISIBLE: 'visible',
  INVISIBLE: 'invisible',
  LIGHT: 'light',
  DARK: 'dark',
  IMAGE_LOADING_PLACEHOLDER: 'image-loading-placeholder',
  RATING: 'rating'
});

export default CLASS_NAMES;
